var Handlebars = require("../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"list") : depth0),{"name":"each","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":3,"column":1},"end":{"line":30,"column":13}}})) != null ? stack1 : "")
    + "\n";
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.lambda, alias3=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <li "
    + ((stack1 = lookupProperty(helpers,"unless").call(alias1,(depth0 != null ? lookupProperty(depth0,"description") : depth0),{"name":"unless","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":4,"column":12},"end":{"line":4,"column":70}}})) != null ? stack1 : "")
    + "> <!-- 2015-04-03 제목만 있을경우 single_line 부여 -->\n            <a href=\"/@"
    + alias3(alias2((depth0 != null ? lookupProperty(depth0,"profileId") : depth0), depth0))
    + "\" class=\"user_info #profile\"> <!-- 2015-04-03 클래스 link_thumb 삭제 -->\n            	<span class=\"ico_brunch_v1 ico_profile\">\n					<img src=\""
    + alias3(__default(require("../static/modernJs/handlebarsHelpers/thumbnail.js")).call(alias1,(depth0 != null ? lookupProperty(depth0,"userImage") : depth0),"C80x80",{"name":"thumbnail","hash":{},"data":data,"loc":{"start":{"line":7,"column":15},"end":{"line":7,"column":52}}}))
    + "\" width=\"40\" height=\"40\" class=\"thumb_g\" alt=\"이미지정보\">\n				</span>\n            </a>\n            <a href=\"/@"
    + alias3(alias2((depth0 != null ? lookupProperty(depth0,"profileId") : depth0), depth0))
    + "\" class=\"link_follow #profile\">\n				<strong class=\"tit_subject\">"
    + alias3(alias2((depth0 != null ? lookupProperty(depth0,"userName") : depth0), depth0))
    + "</strong>\n				<span class=\"desc_follow\">\n					"
    + alias3(alias2((depth0 != null ? lookupProperty(depth0,"description") : depth0), depth0))
    + "\n				</span>\n            </a>\n"
    + ((stack1 = lookupProperty(helpers,"unless").call(alias1,(depth0 != null ? lookupProperty(depth0,"isMe") : depth0),{"name":"unless","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":16,"column":12},"end":{"line":28,"column":23}}})) != null ? stack1 : "")
    + "        </li>\n";
},"3":function(container,depth0,helpers,partials,data) {
    return "class=\"single_line\"";
},"5":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"myWriter") : depth0),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.program(8, data, 0),"data":data,"loc":{"start":{"line":17,"column":12},"end":{"line":27,"column":19}}})) != null ? stack1 : "");
},"6":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <button type=\"button\" id=\"btn_"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"userId") : depth0), depth0))
    + "\" class=\"btn_post btn_subscription #unfollow\" value=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"userId") : depth0), depth0))
    + "\">\n                <span class=\"txt_default\">구독중</span><span class=\"txt_on\">구독해지</span>\n                <span class=\"ico_brunch_v1 ico_subscribe\"></span>\n            </button>\n";
},"8":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <button type=\"button\" id=\"btn_"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"userId") : depth0), depth0))
    + "\" class=\"btn_post btn_default #follow\" value=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"userId") : depth0), depth0))
    + "\">\n                구독하기\n                <span class=\"ico_brunch_v1 ico_subscribe\"></span>\n            </button>\n";
},"10":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"list") : depth0),{"name":"each","hash":{},"fn":container.program(11, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":34,"column":1},"end":{"line":61,"column":13}}})) != null ? stack1 : "")
    + "\n";
},"11":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.lambda, alias3=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <li "
    + ((stack1 = lookupProperty(helpers,"unless").call(alias1,(depth0 != null ? lookupProperty(depth0,"description") : depth0),{"name":"unless","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":35,"column":12},"end":{"line":35,"column":70}}})) != null ? stack1 : "")
    + "> <!-- 2015-04-03 제목만 있을경우 single_line 부여 -->\n            <a href=\"/@"
    + alias3(alias2((depth0 != null ? lookupProperty(depth0,"profileId") : depth0), depth0))
    + "\" class=\"ico_brunch bloger_thumb #profile\"> <!-- 2015-04-03 클래스 link_thumb 삭제 -->\n                <img src=\""
    + alias3(__default(require("../static/modernJs/handlebarsHelpers/thumbnail.js")).call(alias1,(depth0 != null ? lookupProperty(depth0,"userImage") : depth0),"C42x42",{"name":"thumbnail","hash":{},"data":data,"loc":{"start":{"line":37,"column":26},"end":{"line":37,"column":63}}}))
    + "\" width=\"42\" height=\"42\" class=\"img_thumb\" alt=\"이미지정보\"> <!-- 2015-04-03 img 사이즈 변경 -->\n            </a>\n            <a href=\"/@"
    + alias3(alias2((depth0 != null ? lookupProperty(depth0,"profileId") : depth0), depth0))
    + "\" class=\"link_follow #profile\">\n    						<span class=\"cont_follow\">\n    							<strong class=\"tit_subject\">"
    + alias3(alias2((depth0 != null ? lookupProperty(depth0,"userName") : depth0), depth0))
    + "</strong>\n    							<span class=\"desc_follow\">\n                                    "
    + alias3(alias2((depth0 != null ? lookupProperty(depth0,"description") : depth0), depth0))
    + "\n    							</span>\n    						</span>\n            </a>\n"
    + ((stack1 = lookupProperty(helpers,"unless").call(alias1,(depth0 != null ? lookupProperty(depth0,"isMe") : depth0),{"name":"unless","hash":{},"fn":container.program(12, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":47,"column":12},"end":{"line":59,"column":23}}})) != null ? stack1 : "")
    + "        </li>\n";
},"12":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"myWriter") : depth0),{"name":"if","hash":{},"fn":container.program(13, data, 0),"inverse":container.program(15, data, 0),"data":data,"loc":{"start":{"line":48,"column":12},"end":{"line":58,"column":19}}})) != null ? stack1 : "");
},"13":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <button type=\"button\" id=\"btn_"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"userId") : depth0), depth0))
    + "\" class=\"btn_post btn_subscription #unfollow\" value=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"userId") : depth0), depth0))
    + "\">\n                <span class=\"txt_default\">구독중</span><span class=\"txt_on\">구독해지</span>\n                <span class=\"ico_brunch\"></span>\n            </button>\n";
},"15":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <button type=\"button\" id=\"btn_"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"userId") : depth0), depth0))
    + "\" class=\"btn_post btn_default #follow\" value=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"userId") : depth0), depth0))
    + "\">\n                구독하기\n                <span class=\"ico_brunch\"></span>\n            </button>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"isMobile") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(10, data, 0),"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":63,"column":7}}})) != null ? stack1 : "");
},"useData":true});